export default "__VITE_ASSET__BEck28uA__";